<template>
  <div class="page-container">
    <Sidebar />
    
    <div class="main-content">
      <div class="page-header">
        <h1>采销信息审核管理</h1>
      </div>
      
      <div class="filter-bar">
        <input type="text" class="search-input" placeholder="搜索药材名/联系人" v-model="searchText" @keyup.enter="fetchList" />
        <button class="search-btn" @click="fetchList">搜索</button>
        <button :class="['filter-btn', statusFilter === 'all' ? 'active' : '']" @click="statusFilter = 'all'; fetchList()">全部</button>
        <button :class="['filter-btn', statusFilter === 'pending' ? 'active' : '']" @click="statusFilter = 'pending'; fetchList()">待审核</button>
        <button :class="['filter-btn', statusFilter === 'approved' ? 'active' : '']" @click="statusFilter = 'approved'; fetchList()">已通过</button>
        <button :class="['filter-btn', statusFilter === 'rejected' ? 'active' : '']" @click="statusFilter = 'rejected'; fetchList()">已拒绝</button>
      </div>
      
      <div class="content-body">
        <div class="loading" v-if="loading">加载中...</div>
        <div class="error" v-else-if="error">{{ error }}</div>
        
        <div class="table-container" v-else>
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>类型</th>
                <th>药材名</th>
                <th>数量</th>
                <th>价格</th>
                <th>联系人</th>
                <th>联系方式</th>
                <th>审核状态</th>
                <th>发布时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in list" :key="item.id">
                <td>{{ item.id }}</td>
                <td>
                  <span :class="['type-tag', item.type]">{{ getTypeName(item.type) }}</span>
                </td>
                <td>{{ item.herb_name }}</td>
                <td>{{ item.quantity }} {{ item.unit }}</td>
                <td>{{ item.price ? item.price + '元/' + item.unit : '-' }}</td>
                <td>{{ item.contact_person }}</td>
                <td>{{ item.contact_phone }}</td>
                <td>
                  <StatusTag :status="getAuditStatus(item)" :custom-map="{ pending: '待审核', approved: '已通过', rejected: '已拒绝' }" />
                </td>
                <td>{{ formatDate(item.created_at) }}</td>
                <td class="actions">
                  <button class="detail-btn" @click="showDetail(item)">详情</button>
                  <button class="approve-btn" v-if="getAuditStatus(item) !== 'approved'" @click="approvePost(item)">通过</button>
                  <button class="reject-btn" v-if="getAuditStatus(item) !== 'rejected'" @click="rejectPost(item)">拒绝</button>
                  <button class="delete-btn" @click="deletePost(item.id)">删除</button>
                </td>
              </tr>
              <tr v-if="list.length === 0">
                <td colspan="10" class="empty">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div class="pagination" v-if="total > pageSize">
          <button class="page-btn" :disabled="page <= 1" @click="page--; fetchList()">上一页</button>
          <span class="page-info">第 {{ page }} 页 / 共 {{ Math.ceil(total / pageSize) }} 页</span>
          <button class="page-btn" :disabled="page >= Math.ceil(total / pageSize)" @click="page++; fetchList()">下一页</button>
        </div>
      </div>
    </div>
    
    <!-- 详情弹窗 -->
    <div class="modal" v-if="showModal">
      <div class="modal-content detail-modal">
        <h2>采销信息详情</h2>
        <div class="detail-info">
          <div class="detail-row">
            <label>类型：</label>
            <span :class="['type-tag', detailItem.type]">{{ getTypeName(detailItem.type) }}</span>
          </div>
          <div class="detail-row">
            <label>药材名：</label>
            <span>{{ detailItem.herb_name }}</span>
          </div>
          <div class="detail-row">
            <label>规格：</label>
            <span>{{ detailItem.specification || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>数量：</label>
            <span>{{ detailItem.quantity }} {{ detailItem.unit }}</span>
          </div>
          <div class="detail-row">
            <label>价格：</label>
            <span>{{ detailItem.price ? detailItem.price + '元/' + detailItem.unit : '-' }}</span>
          </div>
          <div class="detail-row">
            <label>联系人：</label>
            <span>{{ detailItem.contact_person }}</span>
          </div>
          <div class="detail-row">
            <label>联系电话：</label>
            <span>{{ detailItem.contact_phone }}</span>
          </div>
          <div class="detail-row">
            <label>微信：</label>
            <span>{{ detailItem.contact_wechat || '-' }}</span>
          </div>
          <div class="detail-row">
            <label>产地：</label>
            <span>{{ detailItem.origin_province || '' }}{{ detailItem.origin_city || '' }}{{ detailItem.origin_county || '' }}</span>
          </div>
          <div class="detail-row">
            <label>地址：</label>
            <span>{{ detailItem.province || '' }}{{ detailItem.city || '' }}{{ detailItem.address || '' }}</span>
          </div>
          <div class="detail-row">
            <label>描述：</label>
            <span>{{ detailItem.description || '-' }}</span>
          </div>
          <div class="detail-row" v-if="detailItem.reject_reason">
            <label>拒绝原因：</label>
            <span class="reject-reason">{{ detailItem.reject_reason }}</span>
          </div>
          <div class="detail-row">
            <label>发布时间：</label>
            <span>{{ formatDate(detailItem.created_at) }}</span>
          </div>
          <div class="detail-row" v-if="detailItem.photos && detailItem.photos.length > 0">
            <label>图片：</label>
            <div class="photos">
              <img :src="getPhotoUrl(photo)" v-for="photo in detailItem.photos" :key="photo" class="photo-img" />
            </div>
          </div>
        </div>
        <div class="form-actions">
          <button class="cancel-btn" @click="closeModal">关闭</button>
        </div>
      </div>
    </div>
    
    <!-- 拒绝弹窗 -->
    <div class="modal" v-if="showRejectModal">
      <div class="modal-content">
        <h2>拒绝原因</h2>
        <div class="form-group">
          <label>请输入拒绝原因：</label>
          <textarea v-model="rejectReason" rows="4" placeholder="请说明拒绝原因"></textarea>
        </div>
        <div class="form-actions">
          <button class="cancel-btn" @click="showRejectModal = false">取消</button>
          <button class="submit-btn" @click="confirmReject">确认拒绝</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue'
import StatusTag from '../components/StatusTag.vue'
import axios from 'axios'
import { formatDate } from '../utils/dateFormat'
import { getAdminPassword } from '../utils/api'

export default {
  name: 'TradingList',
  components: { Sidebar, StatusTag },
  data() {
    return {
      list: [],
      loading: true,
      error: '',
      page: 1,
      pageSize: 20,
      total: 0,
      searchText: '',
      statusFilter: 'all',
      showModal: false,
      showRejectModal: false,
      detailItem: {},
      rejectItem: null,
      rejectReason: ''
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          status: this.statusFilter,
          search: this.searchText
        }
        const response = await axios.get('/api/admin/trading-posts', {
          params,
          headers: { 'x-admin-password': getAdminPassword() }
        })
        if (response.data.code === 200) {
          this.list = response.data.data.list || []
          this.total = response.data.data.total || 0
        } else {
          this.error = response.data.msg
        }
      } catch (err) {
        console.error('获取列表失败:', err)
        this.error = '网络错误'
      } finally {
        this.loading = false
      }
    },
    getTypeName(type) {
      const names = { purchase: '采购', sale: '销售' }
      return names[type] || type || '未知'
    },
    getAuditStatus(item) {
      return item.audit_status || 'pending'
    },
    getAuditStatusName(item) {
      const status = item.audit_status || 'pending'
      const names = { pending: '待审核', approved: '已通过', rejected: '已拒绝' }
      return names[status] || '待审核'
    },
    formatDate(dateStr) {
      return formatDate(dateStr)
    },
    getPhotoUrl(photo) {
      if (!photo) return ''
      if (photo.startsWith('http')) return photo
      return 'https://yaotongbao.langya1616.com' + photo
    },
    showDetail(item) {
      this.detailItem = item
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.detailItem = {}
    },
    async approvePost(item) {
      if (!confirm('确定通过该采销信息？')) return
      try {
        await axios.put(`/api/admin/trading-posts/${item.id}/status`, 
          { status: 'approved' },
          { headers: { 'x-admin-password': getAdminPassword() } }
        )
        this.fetchList()
      } catch (err) {
        alert('操作失败')
      }
    },
    rejectPost(item) {
      this.rejectItem = item
      this.rejectReason = ''
      this.showRejectModal = true
    },
    async confirmReject() {
      if (!this.rejectReason.trim()) {
        alert('请输入拒绝原因')
        return
      }
      try {
        await axios.put(`/api/admin/trading-posts/${this.rejectItem.id}/status`, 
          { status: 'rejected', reject_reason: this.rejectReason },
          { headers: { 'x-admin-password': getAdminPassword() } }
        )
        this.showRejectModal = false
        this.rejectItem = null
        this.rejectReason = ''
        this.fetchList()
      } catch (err) {
        alert('操作失败')
      }
    },
    async deletePost(id) {
      if (!confirm('确定删除该采销信息？')) return
      try {
        await axios.delete(`/api/admin/trading-posts/${id}`, {
          headers: { 'x-admin-password': getAdminPassword() }
        })
        this.fetchList()
      } catch (err) {
        alert('删除失败')
      }
    },
    handleLogout() {
      localStorage.removeItem('adminLoggedIn')
      localStorage.removeItem('adminToken')
      sessionStorage.removeItem('adminPassword')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; margin-left: 260px; padding: 30px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.page-header h1 { font-size: 24px; color: #2c3e50; }
.filter-bar { display: flex; gap: 10px; margin-bottom: 20px; align-items: center; }
.search-input { padding: 8px 12px; border: 1px solid #ddd; border-radius: 5px; width: 200px; }
.search-btn { padding: 8px 15px; background: #3498db; color: white; border: none; border-radius: 5px; cursor: pointer; }
.filter-btn { padding: 8px 20px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; }
.filter-btn.active { background: #3498db; color: white; border-color: #3498db; }
.content-body { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
.loading, .error, .empty { text-align: center; padding: 50px; color: #666; }
.table-container { overflow-x: auto; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 12px; text-align: left; border-bottom: 1px solid #eee; }
.data-table th { background: #f8f9fa; color: #2c3e50; font-weight: 600; }
.data-table tr:hover { background: #f5f5f5; }
.type-tag { display: inline-block; padding: 3px 8px; border-radius: 3px; font-size: 12px; }
.type-tag.purchase { background: #27ae60; color: white; }
.type-tag.sale { background: #e74c3c; color: white; }
.status-tag { display: inline-block; padding: 3px 8px; border-radius: 3px; font-size: 12px; }
.status-tag.pending { background: #f39c12; color: white; }
.status-tag.approved { background: #27ae60; color: white; }
.status-tag.rejected { background: #e74c3c; color: white; }
.actions { display: flex; gap: 5px; flex-wrap: wrap; }
.detail-btn, .approve-btn, .reject-btn, .delete-btn { padding: 5px 10px; border: none; border-radius: 3px; cursor: pointer; font-size: 12px; }
.detail-btn { background: #95a5a6; color: white; }
.approve-btn { background: #27ae60; color: white; }
.reject-btn { background: #e74c3c; color: white; }
.delete-btn { background: #bdc3c7; color: #2c3e50; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 20px; }
.page-btn { padding: 8px 15px; background: #3498db; color: white; border: none; border-radius: 5px; cursor: pointer; }
.page-btn:disabled { background: #bdc3c7; cursor: not-allowed; }
.page-info { color: #666; }
.modal { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
.modal-content { background: white; padding: 30px; border-radius: 10px; width: 450px; max-height: 90vh; overflow-y: auto; }
.detail-modal { width: 550px; }
.modal-content h2 { margin: 0 0 20px; }
.detail-info { margin-bottom: 20px; }
.detail-row { display: flex; padding: 8px 0; border-bottom: 1px solid #eee; }
.detail-row label { width: 100px; color: #666; font-weight: 500; }
.detail-row span { flex: 1; }
.reject-reason { color: #e74c3c; }
.photos { display: flex; gap: 10px; flex-wrap: wrap; }
.photo-img { width: 100px; height: 100px; object-fit: cover; border-radius: 5px; }
.form-group { margin-bottom: 15px; }
.form-group label { display: block; margin-bottom: 5px; color: #666; }
.form-group textarea { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; resize: vertical; }
.form-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px; }
.cancel-btn, .submit-btn { padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; }
.cancel-btn { background: #ddd; }
.submit-btn { background: #e74c3c; color: white; }
</style>